<template>
  <div class="blend single-step">
    <FirstSection/>
    <Table v-if="table"/>
    <!-- <div class="button-container">
      <app-btn styling="inline" @click="$store.dispatch('program/goToPrevStep');" class="margin-around">{{ $ml.get(`Previous`) }}</app-btn>
    </div> -->
  </div>
</template>

<script>
import API from '@/api'
import FirstSection from './FirstSection';
import Table from './Table';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      
    }
  },
  created () {
    this.$store.dispatch('program/blend/get');
  },
  methods: {
    
    // printPdf: async function (name, capacity) {
    //   var result = await API.pdf.getPdfForBlend(name, capacity, this.$route.params.programId);
    //   var blob = new Blob([result.data], {type: 'application/pdf'});
    //   var link = document.createElement('a');
    //   link.href = window.URL.createObjectURL(blob);
    //   link.download = 'blend.pdf';
    //   link.click();
    // }
  },
  components: {
    FirstSection,
    Table,
  },
  computed: {
    ...mapGetters({
      table: 'program/blend/table',
      form: 'program/blend/form'
    })
  }
}
</script>

<style lang="scss" scoped>
.button-container {
  display: flex;
  margin-top: 32px;
  .btn {
    margin-left: 0;
  }
}
</style>
